// Mirror `state.currentUser` into `localStorage` so `hasMetabaseUserInfo()`
// (read by `AppSsoProvider.onSigninSilentCallback`) can survive a full page
// reload. Without this, every reload lands with an empty localStorage even
// though the Metabase session cookie is still valid, and the SSO silent
// signin flow kicks in for no reason.
//
// Rendered inside `IasAppShell` so the subscription starts once the redux
// store is wired up, and torn down when the shell unmounts.

import { useEffect } from "react";

import { useStore } from "metabase/redux";

import { persistMetabaseUserInfo, removeMetabaseUserInfo } from "./app-utils";

export const PersistMetabaseUserInfo = (): null => {
  const store = useStore();

  useEffect(() => {
    // Seed from the current state before subscribing so a page-load that
    // already has a user (from `loadCurrentUser`) writes to localStorage
    // even if `state.currentUser` doesn't change again afterwards.
    let previous = store.getState().currentUser;
    if (previous) {
      persistMetabaseUserInfo(previous);
    } else {
      removeMetabaseUserInfo();
    }

    return store.subscribe(() => {
      const next = store.getState().currentUser;
      if (next === previous) {
        return;
      }
      previous = next;
      if (next) {
        persistMetabaseUserInfo(next);
      } else {
        removeMetabaseUserInfo();
      }
    });
  }, [store]);

  return null;
};
